export function linkToAboutPage() {
  return "/about";
}
